import React from "react";
import { Download, FileText, Network, X } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

type DownloadArchiveDialogProps = {
  open: boolean;
  onClose: () => void;
  projectName: string | null;
  transcriptionUrl: string;
  graphUrl: string | null;
};

export function DownloadArchiveDialog({
  open,
  onClose,
  projectName,
  transcriptionUrl,
  graphUrl,
}: DownloadArchiveDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(val) => { if (!val) onClose(); }}>
      <DialogContent className="max-w-md border border-[#E2E8F0] bg-white p-6 shadow-xl rounded-2xl">
        <DialogHeader className="relative pr-6">
          <DialogTitle className="text-lg font-bold text-[#0F172B]">
            Exporter les données du projet
          </DialogTitle>
          <DialogDescription className="text-sm text-[#64748B] mt-1">
            Sélectionnez les fichiers d'archive que vous souhaitez télécharger pour le projet <span className="font-semibold">{projectName}</span>.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-3 mt-4">
          {/* Option 1: Transcription Bundle */}
          <div className="flex items-center justify-between rounded-xl border border-[#E2E8F0] p-4 bg-[#F8FAFC] hover:bg-[#EFF6FF] transition-colors">
            <div className="flex items-center gap-3">
              <FileText className="h-5 w-5 text-[#007AFF]" />
              <div className="flex flex-col">
                <span className="text-[14px] font-semibold text-[#0f172b]">Bundle de Transcription</span>
                <span className="text-[11px] text-[#64748b]">Textes narratifs, voix & citations</span>
              </div>
            </div>
            <a
              href={transcriptionUrl}
              download
              onClick={onClose}
              className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white border border-[#E2E8F0] hover:bg-slate-50 text-[#0F172B] transition-colors shadow-sm"
              title="Télécharger"
            >
              <Download className="h-4 w-4" />
            </a>
          </div>

          {/* Option 2: Knowledge Graph View */}
          {graphUrl && (
            <div className="flex items-center justify-between rounded-xl border border-[#E2E8F0] p-4 bg-[#F8FAFC] hover:bg-[#EFF6FF] transition-colors">
              <div className="flex items-center gap-3">
                <Network className="h-5 w-5 text-[#10B981]" />
                <div className="flex flex-col">
                  <span className="text-[14px] font-semibold text-[#0f172b]">Graphe de Connaissances</span>
                  <span className="text-[11px] text-[#64748b]">Visualisation interactive des relations</span>
                </div>
              </div>
              <a
                href={graphUrl}
                target="_blank"
                rel="noreferrer"
                onClick={onClose}
                className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white border border-[#E2E8F0] hover:bg-slate-50 text-[#0F172B] transition-colors shadow-sm"
                title="Consulter le graphe"
              >
                <Download className="h-4 w-4" />
              </a>
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-9 items-center rounded-lg border border-[#E2E8F0] bg-white px-4 text-sm font-medium text-[#0F172B] transition-colors hover:bg-[#F8FAFC]"
          >
            Fermer
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
